module.exports = __webpack_public_path__ + "arrow_right.svg?dae199ac25e5e578706d163a11568625";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_right.svg
// module id = 18
// module chunks = 0